import {loadLibrary} from '../modules/Util';
import {LIB_URL} from '../App';
import createSlider from '../modules/Slider.js';


function render(rootDom) {
    const SELECTOR = {
        ACTIVE: '_active'
    };
    const $productOffers = $('.js-product-offers', rootDom);
    const TEMPLATE = {
        slide: (data) => `<div class="swiper-slide">
            <div class="swiper-slide__inner">
                <div class="product-card-slide js-product-card-slide" data-image-id="${data.imageId}">
                    <div class="product-card-slide__img">
                        <picture>
                            <source media="(min-width: 280px) and (max-width: 480px)" srcset="${data.imgMob ? data.imgMob : data.img}, ${data.imgMob2x ? data.imgMob2x : data.imgMob} 2x">
                            <img ${data.index ? 'class="swiper-lazy" data-src="' : 'src="'}${data.img}" alt="${data.title}" />
                        </picture>
                    </div>
                    <div class="product-card-slide__title">${data.title}</div>
                </div>
            </div>
        </div>`
    };
    const $slider = $('.js-product-card-slider', rootDom);
    const $dosageList = $('.js-product-card-dosage [data-dosage]', rootDom);
    const $sliderList = $('.swiper-wrapper', $slider);
    let lastProductSliderData;
    let isFirstRun = true;
    let sliderSwiper;
    const baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
    let newUrl;
    let params = new URLSearchParams(document.location.search);

    if (window.localStorage.getItem('pageId')) {
        const breadcrumbsLinks = $(document).find('.js-breadcrumbs a');
        for (let i = 0; i < breadcrumbsLinks.length; i++) {
            if ($(breadcrumbsLinks[i]).attr('href') === '/products/') {
                $(breadcrumbsLinks[i]).attr('href', '/products/?page=1');
            }
            // if ($(breadcrumbsLinks[i]).attr('href') === 'products-store-new-filter.html') {
            //     $(breadcrumbsLinks[i]).attr('href', 'products-store-new-filter.html?page=1');
            // }
        }
    }

    sliderSwiper = createSlider($slider[0], {
        loop: true,
        preloadImages: false,
        lazy: {
            loadPrevNext: false
        }
    });

    App.W.on('load', () => {
        let paramsDosage;
        if (params && params.get('dosage')) {
            paramsDosage = params.get('dosage');
            if ($dosageList.filter(`[data-dosage="${paramsDosage}"]`).length) {
                $dosageList
                    .removeClass(SELECTOR.ACTIVE)
                    .filter(`[data-dosage="${paramsDosage}"]`)
                    .addClass(SELECTOR.ACTIVE);
            }
        }

        setTimeout(() => {
            const activeIndex = sliderSwiper && sliderSwiper.realIndex || 0;

            sliderSwiper && sliderSwiper.destroy();

            sliderSwiper = createSlider($slider[0], {
                loop: true,
                preloadImages: false,
                lazy: {
                    loadPrevNext: true
                },
                initialSlide: activeIndex
            });
        }, 2000);
    });

    $productOffers.on('change init', (e) => {
        let $currProductOption = $productOffers.find(`option[value="${$productOffers.val()}"]`);
        lastProductSliderData = $currProductOption.data('slider') || [];

        let paramsDosage;
        params = new URLSearchParams(document.location.search);

        if (isFirstRun && params && params.get('dosage')) {
            paramsDosage = params.get('dosage');
            if ($productOffers.find(`option[value="${paramsDosage}"]`).length) {
                $currProductOption = $productOffers.find(`option[value="${paramsDosage}"]`);
                lastProductSliderData = $currProductOption.data('slider') || [];
            }

            changeSelectDosage(paramsDosage);
            changeImageSlider(lastProductSliderData, $currProductOption);
        }

        if (isFirstRun) {
            isFirstRun = false;
        } else {
            changeImageSlider(lastProductSliderData, $currProductOption);
        }
        params.set('dosage', $productOffers.val());
        newUrl = baseUrl + '?' + params;
        history.pushState(null, null, newUrl);

        $dosageList
            .removeClass(SELECTOR.ACTIVE)
            .filter(`[data-dosage="${$productOffers.val()}"]`)
            .addClass(SELECTOR.ACTIVE);
    }).trigger('init');

    $dosageList.on('click', (e) => {
        const dosage = $(e.currentTarget).data('dosage');

        changeSelectDosage(dosage);
    });

    $dosageList.one('click', (e) => {
        const dosage = $(e.currentTarget).data('dosage');

        if ($(`.js-common-popup[data-name="${dosage}"]`).length) {
            App.D.trigger('popup:open', {name: dosage});
        }
    });

    if ($dosageList.filter(`.${SELECTOR.ACTIVE}`).is('[data-not-available]')) {
        $dosageList.filter(`:not([data-not-available])`).eq(0).click();
    }

    function changeImageSlider(lastProductSliderData, $currProductOption) {
        sliderSwiper && sliderSwiper.destroy();

        $slider.stop().fadeOut(200, () => {
            $sliderList.html(lastProductSliderData.reduce((html, slideData, i) => html + TEMPLATE.slide({...slideData, imageId: $currProductOption[0].value + '-' + i, index: i}), ''));
            if (lastProductSliderData.length) {
                $slider.fadeIn(200, () => {
                    sliderSwiper = createSlider($slider[0], {
                        loop: true,
                        preloadImages: false,
                        lazy: {
                            loadPrevNext: true
                        }
                    });
                });
            }
        });
    }

    function changeSelectDosage(newDosage) {
        if (newDosage != $productOffers.val()) {
            $productOffers
                .find(`option[value="${newDosage}"]`)
                .prop('selected', true);
            $productOffers.change();
        }
    }


    // слайдер статей продукта
    const $articlesSlider = $('.js-product-articles-slider', rootDom);

    if ($articlesSlider.length) {
        let articlesSliderSwiper = createSlider($articlesSlider[0], {
            loop: true,
            slidesPerGroup: 1,
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                // when window width is >= 768px
                768: {
                    slidesPerGroup: 2,
                    slidesPerView: 2
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerGroup: 3,
                    slidesPerView: 3
                }
            }
        });
    }
}


document.querySelectorAll('.js-product-card').forEach(productDom => {
    loadLibrary(LIB_URL.SWIPER, () => render(productDom));
});
